// this function checks if start of node is reached
const isStartOfNode = (editor) => {
  const { fragment, selection } = editor.value;
  const { anchor } = selection;
  const { key: anchorKeyBefore } = anchor;
  const lengthBefore = fragment.text.length;
  editor.moveAnchorBackward(1);
  let start = false;
  const { selection: selectionAfter, fragment: fragmentAfter } = editor.value;
  const { anchor: anchorAfter } = selectionAfter;
  const { key: anchorKeyAfter } = anchorAfter;
  if (anchorKeyBefore !== anchorKeyAfter) {
    start = true;
  }
  // when offset is 0. i.e. very begining of paragraph
  if (
    fragmentAfter.text.length === lengthBefore &&
    anchorKeyBefore === anchorKeyAfter
  ) {
    start = true;
  }
  if (fragmentAfter.text.length > lengthBefore) {
    editor.moveAnchorForward(1);
  }
  return start;
};

export default isStartOfNode;
